<footer class="govbook-footer">
  <div class="govbook-footer__pre-footer">
    <div class="govbook-container footer-pre-footer-inner">

      <div class="footer-logo">
        <div class="footer-logo__content">
          <a href="https://www.solihull.gov.uk/" target="_blank" rel="noopener noreferrer"
            aria-label="Solihull Metropolitan Borough Council (opens in new window)">
            <img src="assets/images/solihull-logo.png" alt="Solihull Metropolitan Borough Council" class="logo">
          </a>
        </div>
      </div>

      <nav aria-labelledby="block-solihull-footer-menu" id="block-solihull-footer"
        class="block block-menu navigation navigation--footer">
        <h2 class="visually-hidden" id="block-solihull-footer-menu">Footer</h2>
        <ul class="menu menu--footer">
          <li class="menu-item">
            <a target="_blank" aria-label="Contact us (opens in new window)" rel="noopener noreferrer"
              class="footer-links" href="https://www.solihull.gov.uk/Tell-us/Contact-us">Contact us</a>
          </li>
          <li class="menu-item">
            <a target="_blank" aria-label="Privacy (opens in new window)" rel="noopener noreferrer" class="footer-links"
              href="https://www.solihull.gov.uk/privacy">Privacy</a>
          </li>
          <li class="menu-item">
            <a target="_blank" aria-label="About our site (opens in new window)" rel="noopener noreferrer"
              class="footer-links" href="https://www.solihull.gov.uk/SiteInformation">About our site</a>
          </li>
          <li class="menu-item">
            <a target="_blank" aria-label="Accessibility statement (opens in new window)" rel="noopener noreferrer"
                class="footer-links" [routerLink]="['/accessibility-statement']">Accessibility statement</a>
          </li>
        </ul>
      </nav>

      <nav aria-labelledby="block-solihull-socialmedia-menu" id="block-solihull-socialmedia"
        class="block block-menu navigation navigation--social-media">
        <h2 class="visually-hidden" id="block-solihull-socialmedia-menu">Social Media</h2>
        <ul class="menu menu--social-media">
          <li class="menu-item">
            <a target="_blank" rel="noopener noreferrer" aria-label="Follow us on Facebook (opens in new window)"
              href="https://www.facebook.com/solihullcouncil" class="social-media-link-icon--facebook">
              <span></span>
            </a>
          </li>
          <li class="menu-item">
            <a target="_blank" rel="noopener noreferrer" aria-label="Follow us on X (opens in new window)"
              href="https://x.com/solihullcouncil" class="social-media-link-icon--twitter">
              <span></span>
            </a>
          </li>
          <li class="menu-item">
            <a target="_blank" rel="noopener noreferrer" aria-label="Visit us on YouTube (opens in new window)"
              href="https://www.youtube.com/channel/UC7DDSVoAIgTnwgp0Ku8iFLQ" class="social-media-link-icon--youtube">
              <span></span>
            </a>
          </li>
        </ul>
      </nav>

    </div>
  </div>

  <div class="govbook-footer__footer">
    <div class="govbook-container">
      <div class="govbook-row">
        <div class="govbook-row__full">
          <div class="govbook-region govbook-region--footer region region-footer">
            <div class="govbook-container padding-horizontal">
              <div class="govbook-region__inner govbook-region__inner--footer">
                <div id="block-ecc-theme-gov-localgov-poweredbylocalgovdrupal-scarfolk"
                  class="block block-localgov-core block-localgov-powered-by-block">
                  <span>Powered by
                    <a target="_blank" aria-label="Bookinglab | GovBook (opens in new window)"
                      class="govbook-powered-link"
                      href="https://www.bookinglab.co.uk/solutions/gov-book/registrars-and-ceremonies-booking-system/?utm_source=clientbrowser&utm_medium=clientbookingjourney&utm_campaign=registrarsbooking&utm_content=solihull">bookinglab
                      | GovBook</a></span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</footer>